import { render, staticRenderFns } from "./tab_linked.vue?vue&type=template&id=0a596167&scoped=true&"
import script from "./tab_linked.vue?vue&type=script&lang=js&"
export * from "./tab_linked.vue?vue&type=script&lang=js&"
import style0 from "./tab_linked.vue?vue&type=style&index=0&id=0a596167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a596167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a596167')) {
      api.createRecord('0a596167', component.options)
    } else {
      api.reload('0a596167', component.options)
    }
    module.hot.accept("./tab_linked.vue?vue&type=template&id=0a596167&scoped=true&", function () {
      api.rerender('0a596167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/linked/tab_linked.vue"
export default component.exports